/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetNormDto } from './GetNormDto';
import {
    GetNormDtoFromJSON,
    GetNormDtoFromJSONTyped,
    GetNormDtoToJSON,
} from './GetNormDto';

/**
 * 
 * @export
 * @interface GetInterpretationNormDto
 */
export interface GetInterpretationNormDto {
    /**
     * 
     * @type {string}
     * @memberof GetInterpretationNormDto
     */
    id: string;
    /**
     * 
     * @type {GetNormDto}
     * @memberof GetInterpretationNormDto
     */
    norm?: GetNormDto | null;
    /**
     * 
     * @type {number}
     * @memberof GetInterpretationNormDto
     */
    rangeFrom?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetInterpretationNormDto
     */
    rangeTo?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetInterpretationNormDto
     */
    variation?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetInterpretationNormDto
     */
    result?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetInterpretationNormDto
     */
    description?: string | null;
}

/**
 * Check if a given object implements the GetInterpretationNormDto interface.
 */
export function instanceOfGetInterpretationNormDto(value: object): value is GetInterpretationNormDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GetInterpretationNormDtoFromJSON(json: any): GetInterpretationNormDto {
    return GetInterpretationNormDtoFromJSONTyped(json, false);
}

export function GetInterpretationNormDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetInterpretationNormDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'norm': json['norm'] == null ? undefined : GetNormDtoFromJSON(json['norm']),
        'rangeFrom': json['rangeFrom'] == null ? undefined : json['rangeFrom'],
        'rangeTo': json['rangeTo'] == null ? undefined : json['rangeTo'],
        'variation': json['variation'] == null ? undefined : json['variation'],
        'result': json['result'] == null ? undefined : json['result'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function GetInterpretationNormDtoToJSON(value?: GetInterpretationNormDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'norm': GetNormDtoToJSON(value['norm']),
        'rangeFrom': value['rangeFrom'],
        'rangeTo': value['rangeTo'],
        'variation': value['variation'],
        'result': value['result'],
        'description': value['description'],
    };
}

